import axios from 'config/axios';
import Auth from './Auth';

class Teachers {
    static async agreeTC(teacherId) {
        await Auth.checkCurrentAuthToken();
        return await axios.post(`/api/teachers/${teacherId}/terms/agree`, {
            agree: true,
        });
    }

    static async getSchool(groupId) {
        await Auth.checkCurrentAuthToken();
        return await axios.get('/api/schools/' + groupId).then((res) => res.data);
    }

    static async getSchoolTeachers(groupId) {
        await Auth.checkCurrentAuthToken();
        return await axios.get(`/api/teachers/school/${groupId}`).then((res) => res.data);
    }

    static async getSchoolClasses(groupId) {
        await Auth.checkCurrentAuthToken();
        return await axios.get('/api/schools/classes/' + groupId).then((res) => res.data.classes);
    }

    static async getSchoolseeds(groupId, startDate, endDate) {
        await Auth.checkCurrentAuthToken();
        return await axios
            .get(`/api_v2/seeds/group/${groupId}?start=${startDate}&end=${endDate}&aggregate=classId`)
            .then((res) => res.data);
    }

    static async getWeatherHistory({ classId, start, end, range, id }) {
        await Auth.checkCurrentAuthToken();
        return await axios
            .get(`/api/v3/checkin/analytics/class/${classId}?start=${start}&end=${end}&range=${range}`, {
                responseType: 'arrayBuffer',
            })
            .then((res) => res.data);
    }

    static async getStudentWeatherHistory({ id, start, end, range, sentral }) {
        await Auth.checkCurrentAuthToken();
        return await axios
            .get(`/api/v3/checkin/analytics/user/${id}?start=${start}&end=${end}&range=${range}&sentral=${sentral}`, {
                responseType: 'arrayBuffer',
            })
            .then((res) => res.data);
    }

    static async getRawWeatherHistory(start, end, groupId, range) {
        // return await axios.get(`/api_v2/schools/executive/report?start=${start}&end=${end}`);
        return await axios
            .get(`/api/v3/groups/${groupId}/group-exec-report?range=${range}&start=${start}&end=${end}`)
            .then((res) => res.data);
    }

    static async exportWeatherHisotry(classId, start, end) {
        await Auth.checkCurrentAuthToken();
        return await axios
            .get(`/api/teachers/weatherReport/export/${classId}/${start}/${end}`, {
                responseType: 'arrayBuffer',
            })
            .then((res) => res.data);
    }

    static async getExecutiveReport(schoolId, grade) {
        await Auth.checkCurrentAuthToken();
        return await axios.get(`/api/teachers/getExecReport/${schoolId}/${grade}/2021/2`).then((res) => res.data);
    }

    static async getRawReportingHistory() {}

    static async reSendInvite(teacherData) {
        await Auth.checkCurrentAuthToken();
        return await axios.post('/api/admin/teacher/sendInvite', teacherData);
    }
}

export default Teachers;
